import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { useFormState } from 'react-final-form';
import {
  BooleanInput,
  DateInput,
  FormDataConsumer,
  SimpleForm,
  TextInput,
  Button,
  required,
  translate as translateComponent,
} from 'react-admin';
import { nanoid } from 'nanoid';
import {
  AffectationTypeSelectInput,
  CatalogItemAutocompleteInput,
  CleanerAutocompleteInput,
  ConditionalInput,
  ContractAutocompleteInput,
  LeaveSelectInput,
  LeaveAutocompleteInput,
  TimeInput,
  Toolbar,
} from '../../../components';
import { PlanningInput } from '../../../containers';
import {
  dateValidation,
  parseDate,
  planningValidation,
} from '../../../helpers/date';
import { saveAffectationBundle } from '../../../action';
import { buildPlanning } from '../helper';
import { buildCreateRecords } from '../split/executeSplit';
import useReplacementSplitGuard from '../split/useReplacementSplitGuard';

const validate = (values) => {
  console.log('VALUES', values);
  return Object.assign({}, dateValidation(values));
};

export const getMonday = (planning) => {
  if (planning.monday && planning.monday[0] && planning.monday[0].start_time) {
    return '1';
  }
  return '0';
};

export const getTuesday = (planning) => {
  if (
    planning.tuesday &&
    planning.tuesday[0] &&
    planning.tuesday[0].start_time
  ) {
    return '1';
  }
  return '0';
};

export const getWednesday = (planning) => {
  if (
    planning.wednesday &&
    planning.wednesday[0] &&
    planning.wednesday[0].start_time
  ) {
    return '1';
  }
  return '0';
};

export const getThursday = (planning) => {
  if (
    planning.thursday &&
    planning.thursday[0] &&
    planning.thursday[0].start_time
  ) {
    return '1';
  }
  return '0';
};

export const getFriday = (planning) => {
  if (planning.friday && planning.friday[0] && planning.friday[0].start_time) {
    return '1';
  }
  return '0';
};

export const getSaturday = (planning) => {
  if (
    planning.saturday &&
    planning.saturday[0] &&
    planning.saturday[0].start_time
  ) {
    return '1';
  }
  return '0';
};

export const getSunday = (planning) => {
  if (planning.sunday && planning.sunday[0] && planning.sunday[0].start_time) {
    return '1';
  }
  return '0';
};

export const getStartTime = (planning) => {
  if (planning.monday) {
    return planning.monday[0].start_time;
  }
  if (planning.tuesday) {
    return planning.tuesday[0].start_time;
  }
  if (planning.wednesday) {
    return planning.wednesday[0].start_time;
  }
  if (planning.thursday) {
    return planning.thursday[0].start_time;
  }
  if (planning.friday) {
    return planning.friday[0].start_time;
  }
  if (planning.saturday) {
    return planning.saturday[0].start_time;
  }
  if (planning.sunday) {
    return planning.sunday[0].start_time;
  }
  return '00:00:00';
};

export const getEndTime = (planning) => {
  if (planning.monday) {
    return planning.monday[0].end_time;
  }
  if (planning.tuesday) {
    return planning.tuesday[0].end_time;
  }
  if (planning.wednesday) {
    return planning.wednesday[0].end_time;
  }
  if (planning.thursday) {
    return planning.thursday[0].end_time;
  }
  if (planning.friday) {
    return planning.friday[0].end_time;
  }
  if (planning.saturday) {
    return planning.saturday[0].end_time;
  }
  if (planning.sunday) {
    return planning.sunday[0].end_time;
  }
  return '00:00:00';
};

const CheacknerInput = () => {
  const { values } = useFormState();
  console.log();
  // `cleaner_ids` (multi-select, historically create-only) or `cleaner_id`
  // (single-select, edit and now also create — see CleanerAutocompleteInput
  // `multiple` prop in ContractAndCleanerSelectBlock): read whichever is
  // actually populated instead of assuming an array.
  const firstCleanerId = values.cleaner_ids?.[0] ?? values.cleaner_id;
  return (
    <Button
      variant="contained"
      label="🔎 Affectattention 🔎"
      onClick={() => {
        window.open(
          `https://stats.cleany.fr/question/1053?cleaner=${firstCleanerId}&debut=${getStartTime(
            values.planning,
          )}&Vendredi=${getFriday(values.planning)}&Dimanche=${getSunday(
            values.planning,
          )}&Jeudi=${getThursday(values.planning)}&Mercredi=${getWednesday(
            values.planning,
          )}&Mardi=${getTuesday(values.planning)}&Samedi=${getSaturday(
            values.planning,
          )}&Lundi=${getMonday(values.planning)}&Fin=${getEndTime(
            values.planning,
          )}`,
          '_blank',
        );
      }}
      style={{
        marginLeft: 10,
      }}
    />
  );
};

const DaysInput = (props) => {
  return (
    <Fragment>
      <BooleanInput {...props} source="monday" />
      <BooleanInput {...props} source="tuesday" />
      <BooleanInput {...props} source="wednesday" />
      <BooleanInput {...props} source="thursday" />
      <BooleanInput {...props} source="friday" />
      <BooleanInput {...props} source="saturday" />
      <BooleanInput {...props} source="sunday" />
    </Fragment>
  );
};

// Two rows: a fixed "results" row (top) always showing both slots — a card
// once picked, a sober dashed-border placeholder otherwise (see
// EmptyCleanerCardPlaceholder/EmptyContractCardPlaceholder) — cleaner first
// (left), contract second (right); and a "still to fill" row (bottom) below
// with the active autocomplete for whichever slot(s) aren't picked yet (a
// slot in `slot="bottom"` mode renders null once its own value is set, so
// this row naturally shrinks from two inputs down to one, then to none).
// Both rows are flex containers (row, wrap, align-items: stretch so same-row
// siblings match the tallest one's height instead of a fixed value — each
// card/placeholder is capped at 15rem width via its own style). A plain
// top-level <div> as a direct SimpleForm child would get cloned by
// react-admin's FormInput with DOM-invalid props
// (basePath/record/resource/...) — this component absorbs and discards them
// instead (same spirit as DaysInput above, which forwards react-admin props
// onward to real Inputs rather than onto a DOM node).
//
// `show_all` (renamed from the contract-only `show_all_contracts`) is a
// single UI-only toggle shared by both filters: unchecked (default) = both
// filters active (recurring/upcoming contracts only, active cleaners only);
// checked = both disabled (everything reappears, e.g. to backdate an
// affectation on a closed contract or a former cleaner).
const ContractAndCleanerSelectBlock = ({ create }) => {
  const topRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    // `o X o X o` — even gaps everywhere, including at the row's own edges
    // (unlike space-around, which only gives the edges half a gap).
    justifyContent: 'space-evenly',
    gap: 16,
  };
  // The "still to fill" row: active autocompletes side by side, tighter gap
  // than the top row (these are plain inputs, not cards that need breathing
  // room) plus a marginTop to clearly separate this row from the results
  // row above it. justifyContent: flex-start (rather than the default
  // stretch-to-fill behaviour of a lone flex-grow child) keeps a single
  // remaining input left-aligned instead of stretching to fill the row once
  // its sibling slot is filled and renders null.
  const bottomRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 8,
    marginTop: 16,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={topRowStyle}>
        <div style={{ flex: '1 1 15rem' }}>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <CleanerAutocompleteInput
                  validate={required()}
                  name="cleaner"
                  onlyActive={create && !formData.show_all}
                  showSelectedAsCard={create}
                  slot={create ? 'top' : undefined}
                />
              );
            }}
          </FormDataConsumer>
        </div>
        <div style={{ flex: '1 1 15rem' }}>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <ContractAutocompleteInput
                  validate={required()}
                  onlyRecurringOrUpcoming={create && !formData.show_all}
                  showSelectedAsCard={create}
                  slot={create ? 'top' : undefined}
                />
              );
            }}
          </FormDataConsumer>
        </div>
      </div>
      {create && (
        <div style={bottomRowStyle}>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <CleanerAutocompleteInput
                  validate={required()}
                  name="cleaner"
                  onlyActive={!formData.show_all}
                  showSelectedAsCard
                  slot="bottom"
                  bottomSlotStyle={{ flex: '0 1 20rem' }}
                />
              );
            }}
          </FormDataConsumer>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <ContractAutocompleteInput
                  validate={required()}
                  onlyRecurringOrUpcoming={!formData.show_all}
                  showSelectedAsCard
                  slot="bottom"
                  bottomSlotStyle={{ flex: '0 1 20rem' }}
                />
              );
            }}
          </FormDataConsumer>
        </div>
      )}
      {create && (
        <BooleanInput
          source="show_all"
          label="Afficher tout (contrats clos, anciens salariés)"
          helperText="S'applique aux deux sélecteurs ci-dessus"
          defaultValue={false}
        />
      )}
    </div>
  );
};

ContractAndCleanerSelectBlock.propTypes = {
  create: PropTypes.bool,
};

ContractAndCleanerSelectBlock.defaultProps = {
  create: false,
};

const AffectationForm = ({
  create,
  onSubmit,
  onSubmitSplit,
  record,
  save,
  ...props
}) => {
  const defaultValue = create ? { planning: buildPlanning(record) } : undefined;
  // Plan 097 §16 : un `Remplacement` créé ou allongé au-delà de la couverture
  // de son congé ouvre un avertissement, avec le bouton « Découper ». Le
  // `save` du contrôleur d'édition est enveloppé, jamais remplacé.
  const { guard, dialog } = useReplacementSplitGuard({
    create,
    record,
    onSplitCreate: onSubmitSplit,
  });
  const guardedSubmit = (values) => {
    return guard(values, () => {
      onSubmit(values);
    });
  };
  const guardedSave = (values, ...rest) => {
    return guard(values, () => {
      save(values, ...rest);
    });
  };
  return (
    <Fragment>
      <SimpleForm
        {...props}
        initialValues={defaultValue}
        redirect="list"
        record={record}
        validate={validate}
        save={create ? guardedSubmit : guardedSave}
        toolbar={<Toolbar isDeletable={false} />}
      >
        <ContractAndCleanerSelectBlock create={create} />
        <AffectationTypeSelectInput source="type" validate={required()} />
        <ConditionalInput when="type" is="Remplacement">
          <LeaveAutocompleteInput />
        </ConditionalInput>
        <ConditionalInput when="type" is="Ponctuel">
          <TextInput source="punctual_reason" />
        </ConditionalInput>
        <ConditionalInput when="type" is="Absence">
          <LeaveSelectInput source="absence_type" />
        </ConditionalInput>
        <CatalogItemAutocompleteInput
          validate={required()}
          family="Prestations horaires effectuées par Cleany"
        />
        <DateInput
          source="start_date"
          validate={required()}
          parse={parseDate}
        />
        <FormDataConsumer>
          {({ formData }) => {
            return formData.type === 'Remplacement' ? (
              <DateInput
                source="end_date"
                validate={required()}
                parse={parseDate}
              />
            ) : (
              <DateInput source="end_date" parse={parseDate} />
            );
          }}
        </FormDataConsumer>
        {!create && <TimeInput source="start_time" validate={[required()]} />}
        {!create && <TimeInput source="end_time" validate={required()} />}
        {create ? (
          <PlanningInput source="planning" validate={planningValidation} />
        ) : (
          <DaysInput />
        )}
        <CheacknerInput />
      </SimpleForm>
      {dialog}
    </Fragment>
  );
};

AffectationForm.propTypes = {
  create: PropTypes.bool,
  onSubmit: PropTypes.func,
  onSubmitSplit: PropTypes.func,
  record: PropTypes.object,
  save: PropTypes.func,
  translate: PropTypes.func,
};

AffectationForm.defaultProps = {
  create: false,
  record: {},
  onSubmit: /* istanbul ignore next */ () => {},
  onSubmitSplit: /* istanbul ignore next */ () => {},
  save: /* istanbul ignore next */ () => {},
  translate: /* istanbul ignore next */ () => {},
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const toPayload = (values) => {
    // CleanerAutocompleteInput is single-select in create too now (see
    // ContractAndCleanerSelectBlock), so `values` normally only carries
    // `cleaner_id` here — `cleaner_ids` is kept as a fallback for callers
    // that might still populate the array field directly. The backend
    // bundle (care_v1.2 packages/affectations/src/bundle.js
    // `createAffectationFromBundle`) already accepts either a single id or
    // an array on `cleaner_ids`, so wrapping a single id here is required
    // only to keep this payload's shape consistent, not for the backend's
    // sake.
    const cleanerIds = values.cleaner_ids || [values.cleaner_id];
    // `show_all` is a UI-only toggle (see ContractAutocompleteInput
    // `onlyRecurringOrUpcoming` / CleanerAutocompleteInput `onlyActive`)
    // shared by the contract and cleaner selects' filters — it is not an
    // affectation field and must never reach the backend bundle payload.
    // Backend `createBundleFunction` already whitelists the fields it
    // reads (see care_v1.2 packages/affectations/src/bundle.js
    // `initAffectationFromBundle`), so this is defense-in-depth rather than
    // a strict requirement.
    const { show_all: _showAll, ...affectationValues } = values;
    const payload = {
      record: {
        ...affectationValues,
        cleaner_ids: cleanerIds,
        id: values.id ?? nanoid(18),
      },
      redirect: `/cleaner/${cleanerIds[0]}/show`,
      basePath: ownProps.basePath,
    };
    return payload;
  };
  return {
    onSubmit: (values) => {
      dispatch(saveAffectationBundle(toPayload(values)));
    },
    // « Découper » à la création (plan 097 §16) : un bundle par congé, dans
    // un seul createBundle — care les crée tous ou aucun.
    onSubmitSplit: (values, pieces) => {
      const payload = toPayload(values);
      dispatch(
        saveAffectationBundle({
          ...payload,
          record: buildCreateRecords(payload.record, pieces),
        }),
      );
    },
  };
};

const enhance = compose(connect(null, mapDispatchToProps), translateComponent);

export default enhance(AffectationForm);
